export const CUSTOMERAREA = 'espace-client'
export const REGEX_IMG = /(jpg)|(jpeg)|(png)/
export const WEBSITE_LINK = 'https://www.moderlab.com'
export const GENERAL_TERMS_LINK = `${process.env.PRO_SPACE_URL}/espace-pro/general-terms`
export const PRIVACY_POLICY_LINK = `${process.env.PRO_SPACE_URL}/espace-pro/confidentiality`
export const LEGAL_NOTICE_LINK = `${process.env.PRO_SPACE_URL}/espace-pro/legal`
